export default __webpack_public_path__ + "static/with-coffee-tablet-6fb5b3031eed8ef135f24c90a30ecfe3.webp";